"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HasDependentsErrorDescription = exports.DeleteBody = void 0;
var _LoadingElement = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/LoadingElement"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _react = _interopRequireDefault(require("react"));
var _AssetsTable = _interopRequireDefault(require("../AssetsTable"));
var _events = require("../../analytics/events");
var _utils = require("./utils");
var _DefaultDeleteMessage = require("./DefaultDeleteMessage");
var _ConditionalDeleteMessage = require("./ConditionalDeleteMessage");
var _DevelopmentDeleteMessage = require("./DevelopmentDeleteMessage");
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "modal": "DeleteAssetModal__modal__fskZE",
  "header": "DeleteAssetModal__header__YstUx",
  "body": "DeleteAssetModal__body__2lJ_d",
  "footer": "DeleteAssetModal__footer__3EAoC",
  "title": "DeleteAssetModal__title__1dr9Z",
  "text": "DeleteAssetModal__text__FGBfZ",
  "icon": "DeleteAssetModal__icon__h8VY1",
  "warning": "DeleteAssetModal__warning__F0gIV",
  "message": "DeleteAssetModal__message__3wWeG",
  "dependents": "DeleteAssetModal__dependents__3tWFG",
  "subtitle": "DeleteAssetModal__subtitle__2-sRR",
  "versions-container": "DeleteAssetModal__versions-container__1_VSg",
  "versionsContainer": "DeleteAssetModal__versions-container__1_VSg",
  "open-icon": "DeleteAssetModal__open-icon__X5xPP",
  "openIcon": "DeleteAssetModal__open-icon__X5xPP",
  "modal-lg": "DeleteAssetModal__modal-lg__-37XX",
  "modalLg": "DeleteAssetModal__modal-lg__-37XX"
}; 
require('./DeleteAssetModal.css');
var HasDependentsErrorDescription = exports.HasDependentsErrorDescription = function HasDependentsErrorDescription(_ref) {
  var dependents = _ref.dependents;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "warning-message",
    className: styles.warning
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "s",
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(WarningIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.message
  }, /*#__PURE__*/_react.default.createElement("p", null, "This version is used as a dependency for other assets and cannot be deleted."), /*#__PURE__*/_react.default.createElement("p", null, "Remove the dependencies before deleting this version."))), /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "dependents",
    className: styles.dependents
  }, /*#__PURE__*/_react.default.createElement(_AssetsTable.default, {
    onAssetClick: function onAssetClick() {
      return trackEvent(_events.EVENT_TYPES.ASSET_DEPENDENCY_CLICKED);
    },
    assets: dependents,
    title: "Dependent assets",
    caption: "Assets dependents",
    testId: "asset-dependents"
  })));
};
var DeleteBody = exports.DeleteBody = function DeleteBody(_ref2) {
  var _ref2$isPreprocessing = _ref2.isPreprocessingDelete,
    isPreprocessingDelete = _ref2$isPreprocessing === void 0 ? false : _ref2$isPreprocessing,
    renderPreprocessingDelete = _ref2.renderPreprocessingDelete,
    hasDeleteError = _ref2.hasDeleteError,
    renderDependents = _ref2.renderDependents,
    dependents = _ref2.dependents,
    isDeleteBlocked = _ref2.isDeleteBlocked,
    renderErrorDescription = _ref2.renderErrorDescription,
    config = _ref2.config,
    asset = _ref2.asset,
    displayVersionAsMinor = _ref2.displayVersionAsMinor,
    isLastVersion = _ref2.isLastVersion,
    onDeleteTypeChange = _ref2.onDeleteTypeChange;
  var isHardDeletionSettingEnabled = (0, _exchangeReactHooks.useFeatureFlag)('org-level-settings-enabled');
  if (isPreprocessingDelete) {
    return renderPreprocessingDelete ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderPreprocessingDelete()) : /*#__PURE__*/_react.default.createElement(_LoadingElement.default, {
      testId: "loading-delete-modal",
      message: "Validating asset for deletion"
    });
  }
  if (hasDeleteError) {
    return renderDependents ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderDependents({
      dependents: dependents
    })) : /*#__PURE__*/_react.default.createElement(HasDependentsErrorDescription, {
      dependents: dependents
    });
  }
  if (isDeleteBlocked) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderErrorDescription());
  }
  var assetIsInDevelopment = asset.status === 'development';
  if (!isHardDeletionSettingEnabled) {
    var isHardDelete = assetIsInDevelopment || (0, _utils.isWithinDeleteTimeLimit)(asset.createdAt, config.assetDeleteDaysLimit);
    return /*#__PURE__*/_react.default.createElement(_DefaultDeleteMessage.DefaultDeleteMessage, {
      displayVersionAsMinor: displayVersionAsMinor,
      assetDeleteDaysLimit: config.assetDeleteDaysLimit,
      isHardDelete: isHardDelete,
      assetName: asset.name,
      assetMinorVersion: asset.minorVersion,
      assetVersion: asset.version,
      isLastVersion: isLastVersion
    });
  }
  var assetVersion = displayVersionAsMinor ? "".concat(asset.minorVersion, ".x") : asset.version;
  return assetIsInDevelopment ? /*#__PURE__*/_react.default.createElement(_DevelopmentDeleteMessage.DevelopmentDeleteMessage, {
    assetName: asset.name,
    assetVersion: assetVersion,
    isLastVersion: isLastVersion
  }) : /*#__PURE__*/_react.default.createElement(_ConditionalDeleteMessage.ConditionalDeleteMessage, {
    assetName: asset.name,
    assetVersion: assetVersion,
    isLastVersion: isLastVersion,
    onDeleteTypeChange: onDeleteTypeChange
  });
};
//# sourceMappingURL=DeleteBody.js.map